import { render } from "./BaseHeader.vue?vue&type=template&id=5976d67a&scoped=true"
import script from "./BaseHeader.vue?vue&type=script&lang=js"
export * from "./BaseHeader.vue?vue&type=script&lang=js"

import "./BaseHeader.vue?vue&type=style&index=0&id=5976d67a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5976d67a"

export default script